module.exports = __webpack_public_path__ + "img/close_lingua.076e771f.svg";